import React from "react";

import { ATDSStyledContainer, DisplayType } from "@at/design-system-foundation";

import * as Styled from "./skeleton-you-may-also-like.styled";

export const SkeletonYouMayAlsoLike = () => {
  return (
    <ATDSStyledContainer displayType={DisplayType.CONSTRAINED}>
      <Styled.YouMayAlsoLikeLoadingSkeleton>
        <Styled.YouMayAlsoLikeHeading as="h2">
          You may also like
        </Styled.YouMayAlsoLikeHeading>
        <Styled.YouMayAlsoLikeLoadingBodyWindow>
          {Array.from({ length: 4 }).map((_, index) => (
            <Styled.YouMayAlsoLikeLoadingItem key={`loading-item-${index}`} />
          ))}
        </Styled.YouMayAlsoLikeLoadingBodyWindow>
        <Styled.YouMayAlsoLikeLoadingCTA />
      </Styled.YouMayAlsoLikeLoadingSkeleton>
    </ATDSStyledContainer>
  );
};
